import React from "react";
import Select from "@atlaskit/select";
import { HelperMessage } from "@atlaskit/form";

const RSelectList = ({
  title,
  value,
  defaultValue,
  id,
  helperText,
  isMulti = false,
  options,
  isCompact,
  width,
  isDisabled,
  onChange,
  onBlur,
}) => {
  return (
    <>
      {" "}
      <label htmlFor={id}>{title}</label>
      <Select
        name={id}
        className={"ihub-ext-select-field"}
        value={value}
        placeholder={defaultValue}
        spacing={isCompact ? "compact" : "default"}
        isDisabled={isDisabled}
        width={width}
        onChange={onChange}
        onBlur={onBlur}
        options={options}
        isMulti={isMulti}
      />
      <HelperMessage>{helperText}</HelperMessage>
    </>
  );
};
export default RSelectList;
